import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Switch } from '@/components/ui/switch'
import { useUISettingsStore } from '@/store/useUISettingsStore'

import { DEFAULT_IMAGE_READER_SETTINGS, type ImageReaderSettings } from '../../hooks/useImageReaderSettingsQuery'
import { ReaderLayoutFields } from '../../shared/reader-layout-fields'
import { SettingRow } from '../../shared/setting-controls'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  settings: ImageReaderSettings
  onSettingsChange: (settings: ImageReaderSettings) => void
}

export const ImageReaderSettingsDialog = ({ open, onOpenChange, settings, onSettingsChange }: Props) => {
  const isFooterPinned = useUISettingsStore((state) => state.isReaderFooterPinned)
  const setFooterPinned = useUISettingsStore((state) => state.setReaderFooterPinned)
  const setPageTurnAnimation = useUISettingsStore((state) => state.setPageTurnAnimation)

  const handleReset = () => {
    onSettingsChange(DEFAULT_IMAGE_READER_SETTINGS)
    setPageTurnAnimation(true)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gap-3 sm:max-w-md">
        <DialogHeader>
          <DialogTitle>表示設定</DialogTitle>
        </DialogHeader>

        <div className="grid gap-2.5">
          <ReaderLayoutFields
            value={settings}
            onChange={onSettingsChange}
            // 横方向の見開きはページめくりのときだけ使える
            canChoosePageMode={settings.direction === 'ttb' || settings.dragMode === 'snap'}
          />

          <SettingRow label="フッター常時表示" htmlFor="image-footer-pinned" labelClassName="w-auto cursor-pointer">
            <Switch id="image-footer-pinned" checked={isFooterPinned} onCheckedChange={setFooterPinned} />
          </SettingRow>
        </div>

        <DialogFooter>
          <Button variant="outline" size="sm" onClick={handleReset} className="w-full" style={{ borderColor: 'white' }}>
            リセット
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
